import { parseJson } from '#app/utilities/parseJson.js';
import { localStorage } from '../storage.js';
import { type Campaign } from './types.js';

/**
 * The campaign parameters can exist in the URL or in the local storage.
 * If they exist in the local storage, we prefer to use them.
 * Note: Segment's campaign is not equivalent to UTM parameters.
 * Namely, Segment uses "name" instead of "campaign" and we need to provide empty strings for the missing parameters.
 */
export const findCampaign = (): Campaign | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  // eslint-disable-next-line no-restricted-properties
  const currentUrl = new URL(window.location.href);

  const localUtmParametersString = localStorage.getItem(
    'CONTRA_LOCAL_FIRST_UTM_TAG',
  );

  if (localUtmParametersString) {
    const localUtmParameters = parseJson(localUtmParametersString);

    return {
      content: localUtmParameters?.content || '',
      medium: localUtmParameters?.medium || '',
      name: localUtmParameters?.campaign || '',
      source: localUtmParameters?.source || '',
      term: localUtmParameters?.term || '',
    };
  }

  if (currentUrl.searchParams.get('utm_source')) {
    // We are returning empty strings here to make it compatible with Segment's context
    // https://github.com/segmentio/analytics-next/blob/2490333f3c32b922887fdb043ca3101d4c5e25df/src/core/events/interfaces.ts#L63-L79
    return {
      content: currentUrl.searchParams.get('utm_content') || '',
      medium: currentUrl.searchParams.get('utm_medium') || '',
      name: currentUrl.searchParams.get('utm_campaign') || '',
      source: currentUrl.searchParams.get('utm_source') || '',
      term: currentUrl.searchParams.get('utm_term') || '',
    };
  }

  return null;
};
